<div class="notifications-manager">
  <nav class="manager-tabs" aria-label="Secciones de notificaciones">
    <button type="button" [class.active]="activeTab() === 'received'" (click)="setTab('received')">
      <mat-icon>notifications</mat-icon>
      <span>Notificaciones recibidas</span>
      @if (unreadCount() > 0) { <span class="tab-count">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span> }
    </button>
    <button type="button" [class.active]="activeTab() === 'configuration'" (click)="setTab('configuration')">
      <mat-icon>tune</mat-icon>
      <span>Configuraci&#xF3;n</span>
    </button>
  </nav>

  @if (activeTab() === 'received') {
    <section class="received-panel" aria-label="Notificaciones recibidas">
      <div class="received-toolbar">
        <p>Consulta tus avisos y cambia su estado de lectura cuando lo necesites.</p>
        @if (unreadCount() > 0) {
          <button
            type="button"
            class="mark-all-read"
            (click)="markAllAsRead()"
            [disabled]="loading() || savingAllNotifications() || savingNotificationId() !== null"
          >
            <mat-icon>done_all</mat-icon>
            @if (savingAllNotifications()) {
              <span>Marcando...</span>
            } @else {
              <span>Marcar todo como le&#xED;do</span>
            }
          </button>
        }
        <div class="filter-buttons" aria-label="Filtrar notificaciones">
          <button type="button" [class.active]="activeFilter() === 'all'" (click)="setFilter('all')">Todas</button>
          <button type="button" [class.active]="activeFilter() === 'unread'" (click)="setFilter('unread')">No le&#xED;das</button>
          <button type="button" [class.active]="activeFilter() === 'read'" (click)="setFilter('read')">Le&#xED;das</button>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="inbox-error" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>{{ errorMessage() }}</span>
          <button type="button" (click)="loadNotifications(true)">Reintentar</button>
        </div>
      }

      @if (loading() && !notifications().length) {
        <div class="loading-state">
          <p-progressSpinner strokeWidth="4" [style]="{ width: '38px', height: '38px' }"></p-progressSpinner>
          <span>Cargando notificaciones...</span>
        </div>
      } @else if (!notifications().length && !errorMessage()) {
        <div class="empty-state">
          <mat-icon>notifications_none</mat-icon>
          <strong>
            No hay notificaciones
            @if (activeFilter() === 'unread') {
              <span>sin leer</span>
            } @else if (activeFilter() === 'read') {
              <span>le&#xED;das</span>
            }.
          </strong>
          <span>Los avisos que recibas aparecer&#xE1;n aqu&#xED;.</span>
        </div>
      } @else {
        <div class="notification-list">
          @for (notification of notifications(); track notification.id) {
            <article class="notification-card" [class.unread]="!notification.readAt">
              <div class="notification-marker" [class.visible]="!notification.readAt" aria-hidden="true"></div>
              <div class="notification-content">
                <div class="notification-heading">
                  <h3>{{ notification.title }}</h3>
                  <time [attr.datetime]="notification.createdAt">{{ formatDate(notification.createdAt) }}</time>
                </div>
                @if (notification.body) { <p>{{ notification.body }}</p> }
                <div class="notification-actions">
                  @if (notification.url) {
                    <button type="button" class="open-action" (click)="openNotification(notification)">
                      <mat-icon>open_in_new</mat-icon> Abrir
                    </button>
                  }
                  <button type="button" (click)="toggleReadState(notification)" [disabled]="savingNotificationId() === notification.id">
                    <mat-icon>{{ notification.readAt ? 'mark_email_unread' : 'mark_email_read' }}</mat-icon>
                    @if (notification.readAt) {
                      <span>Marcar como no le&#xED;da</span>
                    } @else {
                      <span>Marcar como le&#xED;da</span>
                    }
                  </button>
                </div>
              </div>
            </article>
          }
        </div>
        @if (hasMore()) {
          <div class="load-more-row">
            <button type="button" (click)="loadNotifications(false)" [disabled]="loading()">
              {{ loading() ? 'Cargando...' : 'Cargar anteriores' }}
            </button>
          </div>
        }
      }
    </section>
  } @else {
    <section class="configuration-panel" aria-label="Configuraci&#xF3;n de notificaciones">
      <app-home-notification-settings-dialog [embedded]="true"></app-home-notification-settings-dialog>
    </section>
  }
</div>
